import { configureStore } from "@reduxjs/toolkit";
import counterReduser from "./counterSlice";
import userReducer from "./userSlice";

export default configureStore({
  reducer: {
    counter: counterReduser,
    user: userReducer,
  },
});
